import Axios from "axios";

import {
    getDataWithComp,
    getAlert
} from "./SamuiUtils";

import {
    formatDateTime,
    formatThaiDateUiToDate,
    getCreateDateTime
} from "./DateUtils";

const manageWhArPaymentData = async (
    arId, // AR_ID ของลูกค้านั้นๆ
    arCode, // AR_Code ของสิ่งนั้นๆ
    arName, // ชื่อลูกค้าคนนั้นๆ
    whId, // WarehouseID (Default ไว้ที่ 0 เสมอ)
    docType, // ประเภท เช่น AI/AO
    payAmt, // ค่าจำนวนเงิน
    docId, // ไอดีเอกสาร
    docNo, // เลขเอกสาร
    docNoRef, // เลขเอกสารอ้างอิง
    stcRemark // หมายเหตุ
) => {
    try {
        // Find WH_ARPAYMENT_Onhand By comp_id, item_id, wh_id
        let findItemOnHand = await getDataWithComp("WH_ARPAYMENT_Onhand", `AND Item_Id = ${arId} AND WH_Id = ${whId}`);

        // ถ้าเจอให้ Update WH_ARPAYMENT_Onhand แต่ถ้าไม่เจอให้ Insert WH_ARPAYMENT_Onhand
        if (findItemOnHand.length > 0) {
            // UPDATE WH_ARPAYMENT_Onhand
            await Axios.post(`${process.env.REACT_APP_API_URL}/api/update-wh-ar-payment-on-hand`, {
                last_qty: payAmt,
                item_on_hand: Number(await calculateNewQty(docType, findItemOnHand[0].Item_Onhand, payAmt)),
                last_stc_seq: formatDateTime(new Date()),
                last_stc_date: formatThaiDateUiToDate(getCreateDateTime()) + ".000",
                item_id: arId,
                wh_id: whId,
                comp_id: window.localStorage.getItem('company')
            }, {
                headers: { key: 'SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999' }
            });
        } else {
            // INSERT WH_ARPAYMENT_Onhand
            await Axios.post(`${process.env.REACT_APP_API_URL}/api/insert-wh-ar-payment-onhand`, {
                item_id: arId,
                item_code: arCode,
                item_name: arName,
                item_barcode: null,
                last_qty: payAmt,
                item_on_hand: payAmt > 0 ? -Math.abs(payAmt) : payAmt,
                wh_id: whId,
                zone_id: parseInt("1", 10),
                lt_id: parseInt("1", 10),
                last_stc_seq: formatDateTime(new Date()),
                last_stc_date: formatThaiDateUiToDate(getCreateDateTime()),
                comp_id: window.localStorage.getItem('company'),
                item_last_onhand: null
            }, {
                headers: { key: 'SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999' }
            });
        }

        // ทำการ Insert WH_ARPAYMENT_STC ทุกกรณี
        // Find TOP(1) WH_ARPAYMENT_STC By item_id, wh_id,comp_id ORDER BY STC_SEQ DESC; 
        // => ต้องการ STC_Balance เพื่อมาบวกกับจำนวนรับแล้ว INSERT ใหม่
        let findItemStc = await getDataWithComp("WH_ARPAYMENT_STC", `AND Item_Id = ${arId} AND WH_Id = ${whId} ORDER BY STC_SEQ DESC`);

        //ถ้าเจอให้ Insert WH_ARPAYMENT_STC เอาค่าเดิมมากบวก แต่ถ้าไม่เจอให้ Insert WH_ARPAYMENT_STC เอา 0 + ค่าใหม่
        if (findItemStc.length > 0) {
            // Insert WH_ARPAYMENT_STC เอาค่าเดิมมากบวก
            await Axios.post(`${process.env.REACT_APP_API_URL}/api/insert-wh-ar-payment-stc`, {
                item_id: arId,
                item_code: arCode,
                item_name: arName,
                doc_type: docType,
                ref_balance: parseInt("0", 10),
                stc_qty: payAmt,
                stc_balance: Number(await calculateNewQty(docType, findItemStc[0].STC_Balance, payAmt)),
                stc_date: formatThaiDateUiToDate(getCreateDateTime()),
                stc_by: window.localStorage.getItem('emp_id'),
                comp_id: window.localStorage.getItem('company'),
                doc_id: docId,
                doc_no: docNo,
                doc_noref: docNoRef,
                stc_remark: stcRemark,
                stc_seq: formatDateTime(new Date()),
                wh_id: whId,
                zone_id: parseInt("1", 10),
                lt_id: parseInt("1", 10)
            }, {
                headers: { key: 'SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999' }
            });
        } else {
            // Insert WH_ARPAYMENT_STC เอา 0 + ค่าใหม่
            await Axios.post(`${process.env.REACT_APP_API_URL}/api/insert-wh-ar-payment-stc`, {
                item_id: arId,
                item_code: arCode,
                item_name: arName,
                doc_type: docType,
                ref_balance: parseInt("0", 10),
                stc_qty: payAmt,
                stc_balance: Number(await calculateNewQty(docType, parseInt("0", 10), payAmt)),
                stc_date: formatThaiDateUiToDate(getCreateDateTime()),
                stc_by: window.localStorage.getItem('emp_id'),
                comp_id: window.localStorage.getItem('company'),
                doc_id: docId,
                doc_no: docNo,
                doc_noref: docNoRef,
                stc_remark: stcRemark,
                stc_seq: formatDateTime(new Date()),
                wh_id: whId,
                zone_id: parseInt("1", 10),
                lt_id: parseInt("1", 10)
            }, {
                headers: { key: 'SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999' }
            });
        }
    } catch (error) {
        getAlert("FAILED", error)
        return null;
    }
};

const calculateNewQty = async (docType, currentQty, payAmt) => {
    let newQty;

    switch (docType) {
        case 'IN':
        case 'AI':
        case 'TI':
            newQty = Number(currentQty) + Number(payAmt);
            break;
        case 'OUT':
        case 'AO':
        case 'TO':
            let newPayAmt = payAmt > 0 ? -Math.abs(payAmt) : payAmt;
            newQty = Number(currentQty) + Number(newPayAmt);
            break;
        default:
            throw new Error(`Unsupported docType: ${docType}`);
    }

    return newQty;
};

const setRemarkByPaymentType = async (paymentType) => {
    let remark;

    switch (paymentType) {
        case 1: // 1 เงินสด
            remark = "ชำระเงินผ่านเงินสด";
            break;
        case 2:  // 2 เงินโอน
            remark = "ชำระเงินผ่านเงินโอน";
            break;
        case 3: // 3 เช็ค
            remark = "ชำระเงินผ่านเช็ค";
            break;
        case 4: // 4 เครดิต
            remark = "ชำระเงินผ่านเครดิต";
            break;
        case 5: // 5 ค้างจ่าย
            remark = "ค้างจ่าย";
            break;
        default:
            throw new Error(`Unsupported PaymentType: ${paymentType}`);
    }

    return remark;
};

export { manageWhArPaymentData, setRemarkByPaymentType };